var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 17.7123C12.3371 17.7123 10.1621 15.5498 10.1621 12.8748C10.1621 10.1998 12.3371 8.0498 14.9996 8.0498C17.6621 8.0498 19.8371 10.2123 19.8371 12.8873C19.8371 15.5623 17.6621 17.7123 14.9996 17.7123ZM14.9996 9.9248C13.3746 9.9248 12.0371 11.2498 12.0371 12.8873C12.0371 14.5248 13.3621 15.8498 14.9996 15.8498C16.6371 15.8498 17.9621 14.5248 17.9621 12.8873C17.9621 11.2498 16.6246 9.9248 14.9996 9.9248Z",
    fill: "#E47100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 28.45C13.1501 28.45 11.2876 27.75 9.8376 26.3625C6.1501 22.8125 2.0751 17.15 3.6126 10.4125C5.0001 4.3 10.3376 1.5625 15.0001 1.5625C15.0001 1.5625 15.0001 1.5625 15.0126 1.5625C19.6751 1.5625 25.0126 4.3 26.4001 10.425C27.9251 17.1625 23.8501 22.8125 20.1626 26.3625C18.7126 27.75 16.8501 28.45 15.0001 28.45ZM15.0001 3.4375C11.3626 3.4375 6.6876 5.375 5.4501 10.825C4.1001 16.7125 7.8001 21.7875 11.1501 25C13.3126 27.0875 16.7001 27.0875 18.8626 25C22.2001 21.7875 25.9001 16.7125 24.5751 10.825C23.3251 5.375 18.6376 3.4375 15.0001 3.4375Z",
    fill: "#E47100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI6);
export default __webpack_public_path__ + "static/media/i6.b2ebba6745b2ca0acb0eb27e5a3d54aa.svg";
export { ForwardRef as ReactComponent };